import { render, staticRenderFns } from "./step-product-warranty.html?vue&type=template&id=a4a713ea&"
import script from "./step-product-warranty.js?vue&type=script&lang=js&"
export * from "./step-product-warranty.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./step-product-warranty-i18n.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fr.coelho%2Fprojects%2Fmanor-repair-vue.git%2Fsrc%2Fcomponents%2Forder%2Fstep-product-warranty.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCheckbox,VCol,VContainer,VDatePicker,VMenu,VRadio,VRadioGroup,VRow,VSelect,VSpacer,VTextField})
